import {PlayerReducer, ReducerFromState} from "../../../@types/reducers";
import {ActiveEventIds} from "../../utils/searchFixtures";

export const getActiveEventIds = (state: ReducerFromState<PlayerReducer>): ActiveEventIds =>
    state.player.activeEventIds;
